var map = {
	"./IT-management.jpg": 338,
	"./cloud-services.jpg": 339,
	"./data-center.jpg": 340,
	"./game-development.jpg": 341,
	"./icon1.png": 342,
	"./icon2.png": 343,
	"./icon3.png": 344,
	"./icon4.png": 345,
	"./machine-learning.jpg": 346,
	"./mobile-app-development.jpg": 347,
	"./service-1.jpg": 348,
	"./service-2.jpg": 349,
	"./service-3.jpg": 350,
	"./service-details.jpg": 351,
	"./service-eight-bg.png": 352,
	"./service-five-1.jpg": 353,
	"./service-five-2.jpg": 354,
	"./service-five-3.jpg": 355,
	"./service-five-4.jpg": 356,
	"./service-seven1.png": 357,
	"./service-seven2.png": 358,
	"./service-seven3.png": 359,
	"./software-development.jpg": 360,
	"./web-development.jpg": 361
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 337;